import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateProductQuantity, removeProductFromCart, setDeliveryMethod, finalizePurchase } from '../redux/reducers/cartSlice';
import { Button, Row, Col, Form, Image, Card } from 'react-bootstrap';
import MenuPrincipal from '../components/menuPrincipal';
import '../style/cartPage.css'
import { useNavigate } from 'react-router-dom';
import Rodape from "../components/rodape";
const CartPage = () => {
    const dispatch = useDispatch();
    const { products, totalAmount } = useSelector((state) => state.cart);
    const [pickupInStore, setPickupInStore] = useState(false);
    const navigate = useNavigate();
    console.log(useSelector((state) => state.cart), 'useSelector((state) => state.cart)')
    const BASE_URL = process.env.REACT_APP_BASE_URL
    const handleQuantityChange = (productId, quantity) => {
        dispatch(updateProductQuantity({ productId, quantity }));
    };

    const handleRemoveProduct = (productId) => {
        dispatch(removeProductFromCart(productId));
    };

    const handleSetDeliveryMethod = (method) => {
        dispatch(setDeliveryMethod(method));
    };


    const handleFinalizePurchase = () => {
        navigate('/checkout');
    };

    return (
        <div>
            <MenuPrincipal />
            <div className={products.length === 0 ? 'section-spacing-5' : 'section-spacing-4'}>
                <div className="cart-page">
                    <h2 className="text-center mb-4"> <i class="fa-solid fa-cart-shopping"></i> Seu Carrinho</h2>
                    <Row>
                        <Col xs={12} md={6} lg={6} className="mb-4">
                            {products.length === 0 ? (
                                <p className="text-center cart-vazio">Seu carrinho está vazio.</p>
                            ) : (
                                <div>
                                    {products.map((product) => (
                                        <Row key={product.id} className="mb-4 card-item">
                                            <Col xs={12} md={6} lg={6}>
                                                <img
                                                    alt={product.name}
                                                    className="cart-product-image"
                                                    src={
                                                        product?.images[0]?.url
                                                            ? product.images[0].url.startsWith("data:image") // Verifica se é base64
                                                                ? product.images[0].url // Base64
                                                                : `${BASE_URL}storage/${product.images[0].url}` // Caminho no servidor
                                                            : "default-image-path" // Caminho para uma imagem padrão
                                                    }
                                                />
                                            </Col>
                                            <Col xs={12} md={6} lg={6}>
                                                <h4>{product.name}</h4>
                                                <span className="cart-product-price">
                                                    <p>{Number(product.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                                </span>
                                                <div className="quantity-control">
                                                    <Form.Label>Quantidade:</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="1"
                                                        value={product.quantity}
                                                        onChange={(e) =>
                                                            handleQuantityChange(product.id, parseInt(e.target.value))
                                                        }
                                                    />
                                                </div>
                                                <Button
                                                    variant="outline-danger"
                                                    className="mt-3"
                                                    onClick={() => handleRemoveProduct(product.id)}
                                                >
                                                    Remover
                                                </Button>
                                            </Col>
                                        </Row>
                                    ))}
                                </div>
                            )}
                        </Col>
                        <Col xs={12} md={6} lg={6}>
                            {/* Opção de Retirada na Loja */}
                            <div className="pickup-option opcao-pag">
                                <h4><i class="fa-solid fa-truck"></i> Formas de entrega</h4>
                                <Form.Check
                                    type="checkbox"
                                    label="Retirada na loja"
                                    checked={pickupInStore}
                                    onChange={(e) => setPickupInStore(e.target.checked)}
                                />
                            </div>
                        </Col>
                        <div className="cart-summary-2">
                            <p><span className='total'><i class="fa-solid fa-money-bill-wave icone-total"></i>Total: </span>{totalAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                        </div>
                    </Row>
                    {/* Botão de Finalizar Compra */}
                    {products.length > 0 && (
                        <div className="finalize-purchase mt-4 text-center">
                            <Button variant="primary" onClick={handleFinalizePurchase}>
                                Finalizar Compra
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            <Rodape />
        </div>
    );
};

export default CartPage;
